module.exports = __webpack_public_path__ + "static/media/solutions_cn.99e5d447.jpg";